module.exports = __webpack_public_path__ + "static/img/slide2.c1307d63.jpg";